export default __webpack_public_path__ + "static/media/svg-5.f5d94d10.svg";